import Vue from 'vue'
import VueRouter from 'vue-router'
import dashboard from '../views/dashboard.vue'
import login from '../views/login.vue'
import users from '../views/users.vue'
import agencies from '../views/agencies.vue'
import singleAgency from '../views/singleAgency.vue'
import singleReport from '../views/singleReport.vue'
import singleSubscription from '../views/singleSubscription.vue'
import demoReport from '../views/demoReport.vue'
import insightsReport from '../views/insightsReport.vue'
import singleCancelledSubscription from '../views/singleCancelledSubscription.vue'
import cancelledSubscriptions from '../views/cancelledSubscriptions.vue'
import instagramInsightsReport from '../views/instagramInsightsReport.vue'
import facebookInsightsLive from '../views/facebookInsightsLive.vue'
import demoSubscriptions from '../views/demoSubscriptions.vue'
import resellerDemoSubscriptions from '../views/resellerDemoSubscriptions.vue'
import singleUserView from '../views/singleUserView.vue'
import frontendPackages from '../views/frontendPackagesPaypal.vue'
import singlePausedSubscription from '../views/singlePausedSubscription.vue'
import createSingleSubscription from '../views/createSingleSubscription.vue'
import createAccount from '../views/createAccount.vue'

import agencySubscriptions from '../views/agencySubscriptions.vue'

//testingpages
import testingSimonLiveData from '../views/testingSimonLiveData.vue'

import {firebaseApp} from '../firebaseConfig'
import {getAuth, onAuthStateChanged} from 'firebase/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/create-account',
    name: 'createAccount',
    component: createAccount,
  },
  {
    path: '/create-account/:title',
    name: 'createAccount',
    component: createAccount,
    props:true,
  },
  {
    path: '/',
    name: 'dashboard',
    component: dashboard,
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/users',
    name: 'users',
    component: users,
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/user/:id',
    name: 'singleUserView',
    component: singleUserView,
    meta:{
      requiresAuth: true
    },
    props:true
  },
  {
    path: '/create-subscription/:title',
    name: 'createSingleSubscription',
    component: createSingleSubscription,
    props:true,
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/agencies',
    name: 'agencies',
    component: agencies,
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/agency-subscriptions',
    name: 'agencySubscriptions',
    component: agencySubscriptions,
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/reseller-subscriptions',
    name: 'agencySubscriptions',
    component: agencySubscriptions,
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/agency-demos',
    name: 'demoSubscriptions',
    component: demoSubscriptions,
    meta: {
      requiresAuth:true
    }
  },
  {
    path: '/reseller-demos',
    name: 'resellerDemoSubscriptions',
    component: resellerDemoSubscriptions,
    meta: {
      requiresAuth:true
    }
  },
  {
    path: '/agency/:id',
    name: 'singleAgency',
    component: singleAgency,
    meta:{
      requiresAuth: true
    },
    props:true
  },
  {
    path: '/agency/:id/subscription/:uid',
    name: 'singleSubscription',
    component: singleSubscription,
    meta:{
      requiresAuth: true
    },
    props:true
  },
    {
    path: '/agency/:id/cancelled-subscription/:uid',
    name: 'singleCancelledSubscription',
    component: singleCancelledSubscription,
    meta:{
      requiresAuth: true
    },
    props:true
  },
  {
    path: '/agency/:id/paused-subscription/:uid',
    name: 'singlePausedSubscription',
    component: singlePausedSubscription,
    meta:{
      requiresAuth: true
    },
    props:true
  },
  {
    path: '/agency-cancelled-subscriptions',
    name: 'cancelledSubscriptions',
    component: cancelledSubscriptions,
    meta:{
      requiresAuth: true
    },
    props:true
  },
  {
    path: '/agency/:id/subscription/:uid/report/:reportId',
    name: 'singleReport',
    component: singleReport,
    props:true
  },
  {
    path: '/agency/:id/subscription/:uid/insights-report/:reportId',
    name: 'insightsReport',
    component: insightsReport,
    props:true
  },
  {
    path: '/agency/:id/subscription/:uid/instagram-insights-report/:reportId',
    name: 'instagramInsightsReport',
    component: instagramInsightsReport,
    props:true
  },
  {
    path: '/demo-report/:reportId',
    name: 'demoReport',
    component: demoReport,
    // meta:{
    //   requiresAuth: true
    // },
    props:true
  },
  {
    path: '/packages/:title/:demoReportId/:url',
    name: 'frontendPackages',
    component: frontendPackages,
    props:true
  },
    {
    path: '/packages/:title',
    name: 'frontendPackages',
    component: frontendPackages,
    props:true
  },
  {
    path: '/livefacebook',
    name: 'facebookInsightsLive',
    component: facebookInsightsLive,
  },
  {
    path: '/facebooklive',
    name: 'testingSimonLiveData',
    component: testingSimonLiveData,
  },
  {
    path: "*",
    redirect: "/",
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const auth = getAuth(firebaseApp)
const getUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe()
      resolve(user)
    },reject)
  })
}

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  console.log('requiresAuth',requiresAuth)
  const routeExists = router.options.routes.some(route => route.name === to.name)
  console.log('routeExists',routeExists)
  if(requiresAuth && !await getUser()){
    alert('You need to be signed in')
    next('/login')
  } else{
    if(!routeExists){
      next('/login')
    }else{
      console.log('requiresAuth to dashboard page', requiresAuth)
      next()
    }
  }
})

export default router
